<script lang="ts" setup>
import 'markstream-vue/index.css';

import { computed } from 'vue';
import MarkdownRender from 'markstream-vue';
import type { AssistantMessage } from './types';

const props = defineProps<{
  message: AssistantMessage;
}>();

const isAssistant = computed(() => props.message.role === 'assistant');
const messageContent = computed(() => {
  if (props.message.content) {
    return props.message.content;
  }

  if (props.message.status === 'streaming') {
    return '正在生成...';
  }

  if (props.message.status === 'failed') {
    return '暂时无法回复，请稍后再试。';
  }

  if (props.message.status === 'canceled') {
    return '已取消生成。';
  }

  return '';
});
const isStreaming = computed(() => props.message.status === 'streaming' && Boolean(props.message.content));
const isFinal = computed(() => props.message.status !== 'streaming');
const markdownIndexKey = computed(() => props.message.messageId || props.message.id);
</script>

<template>
  <div
    class="max-w-[86%] min-w-0 break-words rounded-15 px-14 py-11 text-14 leading-23"
    :class="
      isAssistant
        ? 'self-start rounded-bl-5 bg-#EEF6FF text-#25324B'
        : 'self-end rounded-br-5 bg-#1281FF text-white'
    "
  >
    <MarkdownRender
      v-if="isAssistant"
      class="assistant-message-markdown"
      mode="chat"
      html-policy="escape"
      :content="messageContent"
      :fade="false"
      :final="isFinal"
      :index-key="markdownIndexKey"
      :render-code-blocks-as-pre="true"
      :smooth-streaming="isStreaming ? 'auto' : false"
      :typewriter="isStreaming"
    />

    <span v-else class="whitespace-pre-wrap">
      {{ messageContent }}
    </span>
  </div>
</template>

<style lang="scss" scoped>
.assistant-message-markdown {
  display: block;
  min-width: 0;
  max-width: 100%;
  color: inherit;
  font-size: 14px;
  font-family: inherit;

  &:deep() {
    .paragraph-node {
      margin: 0;
    }

    .heading-1 {
      margin-bottom: 14px;
      font-size: 20px;
    }

    .heading-2 {
      margin-top: 0;
      margin-bottom: 10px;
      font-size: 18px;
    }

    .heading-3 {
      margin-top: 0;
      margin-bottom: 10px;
      font-size: 16px;
    }

    .heading-4 {
      margin-top: 0;
      margin-bottom: 10px;
      font-size: 14px;
    }

    .code-block-container,
    .table-node {
      max-width: 100%;
    }
  }
}
</style>
